import PhfExposure from './PhfExposure';

export enum PhfDiningCarCustomMetricKey {
    /** 餐车订单 接单重试 */
    'CANCHE_ORDER_CONFIRM_RETRY' = 'CANCHE_ORDER_CONFIRM_RETRY',
    /** 餐车订单 出餐重试 */
    'CANCHE_ORDER_FOOD_DONE_RETRY' = 'CANCHE_ORDER_FOOD_DONE_RETRY',
    /** 餐车订单 取消重试 */
    'CANCHE_ORDER_CANCEL_RETRY' = 'CANCHE_ORDER_CANCEL_RETRY',
    /** 餐车订单 商家同意取消订单重试 */
    'CANCHE_ORDER_ARGEE_CANCEL_RETRY' = 'CANCHE_ORDER_ARGEE_CANCEL_RETRY',
    /** 餐车订单 商家拒绝取消订单重试 */
    'CANCHE_ORDER_REFUSE_CANCEL_RETRY' = 'CANCHE_ORDER_REFUSE_CANCEL_RETRY',
    /** 获取打印模板，广告等数据后json解析失败*/
    'PHF_DININGCAR_PRINT_GET_MODEL_FAIL' = 'PHF_DININGCAR_PRINT_GET_MODEL_FAIL',
}

export enum ACTION_STATUS {
    SUCCESS,
    FAIL,
}

export const reportPhfCardCustomMetrics = (params: {
    key: PhfDiningCarCustomMetricKey;
    tags: { [key: string]: any };
    status?: ACTION_STATUS;
}) => {
    const Exposure = PhfExposure.getInstance();
    const { key, tags, status = ACTION_STATUS.SUCCESS } = params;

    Exposure.reportPhfCardCustomMetrics(key, 1, { status, ...tags });
};
